import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { NbDialogService } from '@nebular/theme';
@Component({
  template: `
    <div class="d-flex">
      <div *ngIf="event.default_event_checked" class="d-flex align-items-center justify-content-center">
          Evento agregado
      </div>

      <div *ngIf="value.role_logged_user !== 'viewAndDownloadOnly' && !event.default_event_checked" class="d-flex align-items-center justify-content-center">
        <button nbButton class="mt-3" size="small" status="success" (click)="save.emit(event)">
          Agregar evento
        </button>
      </div>
    </div>
  `,
})
export class ActionsDefaultEvents implements ViewCell, OnInit {
  @Input() value: any;    // This hold the cell value
  @Input() rowData: any;
  @Output() save: EventEmitter<any> = new EventEmitter();
  event: any;

  constructor(
    private dialogService: NbDialogService,
  ) {
  }

  async ngOnInit() {
    this.event = this.rowData;
  }
}
